<template>
    <div>
        <label :for="id" class="stage-filter-label block mb-2">{{ label }}</label>
        <div class="mt-1 flex rounded">
            <div class="relative flex items-stretch flex-grow focus-within:z-10">
                <div :style="{backgroundColor: input}" class="absolute rounded-l-md inset-y-0 left-0 w-10 flex items-center pointer-events-none border-r border-line"/>
                <input
                    :id="id"
                    v-model="input"
                    :placeholder="placeholder"
                    :required="required"
                    aria-label="Color picker"
                    class="stage-filter-input form-input rounded-none rounded-l-md pl-12 block w-full text-sm transition duration-150 ease-in-out sm:leading-5"
                >
            </div>
            <button
                class="-ml-px relative rounded-r-md inline-flex items-center px-3 py-2 border border-line text-sm leading-5 font-medium hover:bg-gray-100 hover:text-gray-500 focus:outline-none active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                style="box-shadow: none;"
                type="button"
                @click="openNativePicker"
            >
                <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.eye-dropper-solid"></svg-vue>
            </button>
        </div>
        <input
            :id="id + '-picker'"
            ref="nativePicker"
            :value="nativeColorValue"
            class="sr-only"
            tabindex="-1"
            type="color"
            @input="pickNativeColor"
        >
    </div>
</template>

<script>
export default {
    name: "input-color",
    emits: ['input', 'update:modelValue'],
    props: {
        modelValue: {
            required: false,
            default: undefined,
        },
        value: {
            required: false
        },
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        input: {
            get() {
                return this.modelValue !== undefined ? this.modelValue : this.value;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        },
        nativeColorValue() {
            const value = String(this.input || '').trim();
            return /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(value) ? value : '#000000';
        }
    },
    methods: {
        pickNativeColor(event) {
            const value = event && event.target ? event.target.value : '';
            this.input = value;
        },
        openNativePicker() {
            const picker = this.$refs.nativePicker;
            if (!picker) {
                return;
            }

            if (typeof picker.showPicker === 'function') {
                picker.showPicker();
                return;
            }

            picker.click();
        },
    }
}
</script>
